import InstitutionBranchOperationsForm from '@/features/institution/branch-operations/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingBranchOperationsPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="branchOperations" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionBranchOperationsForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingBranchOperationsPage.displayName = 'InstitutionOnboardingBranchOperationsPage';

export default InstitutionOnboardingBranchOperationsPage;
